// YouTube 视频 ID 固定是 11 位（字母/数字/下划线/中划线），不管出现在链接的哪个位置，
// 只要凑够这个长度、前后不再挨着别的合法 ID 字符，就一定是视频 ID。
const YOUTUBE_ID_RE = /^[\w-]{11}$/;

/**
 * 从任意常见的 YouTube 分享链接里解析出视频 ID：标准 watch 链接、youtu.be 短链接
 * （可能带 ?si= 追踪参数或结尾多个斜杠）、/shorts/、/embed/、/live/。
 * 解析不出来（域名不对、或者链接里根本没有合法 ID）时返回 null。
 */
export function extractYoutubeId(rawUrl?: string | null): string | null {
  if (!rawUrl) return null;
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    return null;
  }
  const host = url.hostname.toLowerCase();

  if (host === 'youtu.be') {
    const id = url.pathname.split('/').filter(Boolean)[0] || '';
    return YOUTUBE_ID_RE.test(id) ? id : null;
  }

  if (host === 'youtube.com' || host === 'www.youtube.com' || host === 'm.youtube.com') {
    const vParam = url.searchParams.get('v');
    if (vParam && YOUTUBE_ID_RE.test(vParam)) return vParam;
    const segments = url.pathname.split('/').filter(Boolean);
    const pathPrefixes = ['shorts', 'embed', 'live', 'v'];
    if (segments.length >= 2 && pathPrefixes.includes(segments[0].toLowerCase())) {
      const id = segments[1];
      if (YOUTUBE_ID_RE.test(id)) return id;
    }
    return null;
  }

  return null;
}

/**
 * YouTube 官方提供的静态缩略图地址，按固定规律拼接，不需要调用任何接口、不受跨域限制。
 * hqdefault 是所有视频都保证存在的档位（部分冷门视频没有更高清的 maxresdefault）。
 */
export function getYoutubeThumbnailUrl(rawUrl?: string | null): string | null {
  const id = extractYoutubeId(rawUrl);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
}
